import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Box} from "../../../services/box/box.model";
import {Document} from "../../../services/document/document.model";

@Component({
  selector: 'app-modale-box',
  templateUrl: './modale-box.component.html',
  styleUrls: ['./modale-box.component.scss']
})
export class ModaleBoxComponent implements OnInit {

  box: Box;
  constructor(@Inject(MAT_DIALOG_DATA) public data: Document,
              public dialogRef: MatDialogRef<ModaleBoxComponent>) {
    this.box = data.box_obj;
  }

  ngOnInit(): void {
  }
  onClosed() {
    this.dialogRef.close();
  }

}
